import { auth } from './firebase'

export const getIdToken = async (forceRefresh = false): Promise<string | null> => {
  const user = auth.currentUser
  if (!user) return null
  try {
    return await user.getIdToken(forceRefresh)
  } catch (err) {
    console.error('Failed to get Firebase ID token', err)
    return null
  }
}

export const PENDING_PROVISION_KEY = 'fc_pending_provision'

export interface PendingProvision {
  fullName: string
  companyName: string
}

export const savePendingProvision = (p: PendingProvision) => {
  localStorage.setItem(PENDING_PROVISION_KEY, JSON.stringify(p))
}

export const readPendingProvision = (): PendingProvision | null => {
  const raw = localStorage.getItem(PENDING_PROVISION_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as PendingProvision
  } catch {
    return null
  }
}

export const clearPendingProvision = () => {
  localStorage.removeItem(PENDING_PROVISION_KEY)
}
